import SidebarHeaderLayout from "../HOC/SidebarHeaderLayout";

const Dashoard = () => {
  return <div className="flex justify-center items-center">Dashboard</div>;
};

export default SidebarHeaderLayout(Dashoard);
